import type { Feature } from '@luna/gatekeeper';

export const contactlessPayments: Feature = {
    enabled: true,
    _description:
        'Displays contactless payments card in the bank card settings page and credit card functions page',
};
